import { useTranslate } from "@tolgee/react";
import React from "react";
import {
  Capabilities,
  TplApplicableFor,
} from "../../../../clients/graphqlTypes.js";

const DOCUMENTS: Array<{ type: TplApplicableFor; capability?: Capabilities }> =
  [
    { type: "QUOTE" },
    { type: "REQUIREMENT", capability: "requirements" },
    { type: "BUILDING" },
  ];

export function useTemplateAvaliableFor() {
  const { t } = useTranslate(["Quote", "Requirements", "Buildings"]);

  const labels: Record<TplApplicableFor, string> = React.useMemo(
    () => ({
      QUOTE: t("Quote", { ns: "Quote" }),
      REQUIREMENT: t("Requirement", { ns: "Requirements" }),
      BUILDING: t("Building", { ns: "Buildings" }),
    }),
    [t]
  );

  const options = React.useMemo(
    () =>
      DOCUMENTS.map(({ type, capability }) => ({
        value: type,
        label: labels[type],
        capability,
      })),
    [labels]
  );

  return {
    documents: DOCUMENTS.map(document => document.type),
    options,
    labels,
  };
}
